import { Activity, Shield } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { generateDeepAnalysisReport } from '../../services/geminiService';

interface ExecutiveBriefProps {
    contract: any;
}

export function ExecutiveBrief({ contract }: ExecutiveBriefProps) {
    return (
        <div className="bg-[#0A0A0A]/50 backdrop-blur-sm p-8 rounded-3xl border border-white/5">
            <div className="flex items-center gap-3 mb-6">
                <div className="p-2 bg-purple-500/10 rounded-lg">
                    <Activity className="w-5 h-5 text-purple-400" />
                </div>
                <h2 className="text-xl font-bold text-white tracking-tight">Executive Summary</h2>
            </div>
            <div className="prose prose-invert text-gray-400 leading-relaxed text-sm">
                <div className="mb-6 first-letter:text-2xl first-letter:text-white first-letter:font-bold first-letter:mr-1">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {contract?.aiSummary || generateDeepAnalysisReport(contract || {})}
                    </ReactMarkdown>
                </div>
                <h4 className="text-gray-500 font-bold uppercase text-[10px] tracking-widest mb-3 mt-6">Scope of Work</h4>
                <p className="text-xs font-mono bg-black/40 p-5 rounded-xl border border-white/5 text-gray-500">
                    {contract?.description?.substring(0, 600)}...
                </p>

                {contract?.teamingSuggestions && contract.teamingSuggestions.length > 0 && (
                    <div className="mt-8 pt-8 border-t border-white/5">
                        <h4 className="text-purple-400 font-bold uppercase text-[10px] tracking-widest mb-4 flex items-center gap-2">
                            <Shield className="w-3 h-3" /> Strategic Teaming & Partnerships
                        </h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {contract.teamingSuggestions.map((suggestion: any, i: number) => (
                                <div key={i} className="bg-white/5 border border-white/10 p-4 rounded-2xl hover:bg-white/[0.07] transition-all group">
                                    <div className="flex justify-between items-start mb-2">
                                        <h5 className="text-sm font-bold text-white group-hover:text-purple-400 transition-colors">{suggestion.name}</h5>
                                        <span className="text-[9px] bg-purple-500/10 text-purple-400 px-2 py-0.5 rounded-full border border-purple-500/20 font-bold uppercase letter-spacing-widest">Recommended</span>
                                    </div>
                                    <p className="text-xs text-gray-400 line-clamp-2 mb-2">{suggestion.rationale}</p>
                                    <div className="flex items-center gap-2">
                                        <span className="text-[10px] text-gray-600 font-bold uppercase">Gap Filled:</span>
                                        <span className="text-[10px] text-white bg-blue-500/10 px-2 py-0.5 rounded border border-blue-500/20">{suggestion.gapFilled}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
